var _defs, _path, _line, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_9",
    "data-name": "Capa 9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.85 379.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 30px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #9362c7;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 15px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.55,229.47s26.93,31.27,53.83,7.31c9.27-8.26,10.7-18.34,9.01-29.18-2.03-12.97-16.27-22.04-28.74-26.15-14.03-4.63-32.18-11.24-31.83-30.85,.43-24.78,30.36-42.09,54.77-11.94"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 183.22,
    y1: 101.13,
    x2: 183.88,
    y2: 269.12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 183.88,
    cy: 186.08,
    r: 115.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 183.88,
    cy: 186.08,
    r: 156.78
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.0765dc7142b94b473dd6f0a25d2ad025.svg";
export { ForwardRef as ReactComponent };